export default __webpack_public_path__ + "static/media/plano-museo-oscuro.c798acfb.png";